module.exports = __webpack_public_path__ + "img/header-bgr.e8c8e4ca.png";